import React from 'react';
import styles from './XPanel.module.scss';
import {} from "../../Utilities/Utilities";
import { XComponent } from '../commons/XComponent';
import { IComponentState } from '../commons/IComponentState';
import { IComponentProps } from '../commons/IComponentProps';
import { EOrientation } from '../../types/enums/EOrientation';
import XIcons from '../../icons/XIcons';



export interface IPanelProps extends IComponentProps {
    children? : React.ReactNode;
    orientation? : EOrientation;
}

export interface IPanelState extends IComponentState {
}

export class XPanel extends XComponent<HTMLDivElement, IPanelProps, IPanelState> {
    public constructor(props: any) {
        super(props);
    }
    public render(): React.ReactNode {
        return (
            <div className={styles.XPanel} data-orientation={this.props.orientation}>
                {this.props.orientation === EOrientation.Horizontal && <XIcons.MoreHorizontal className={styles.XIcon}/>}
                {this.props.orientation === EOrientation.Vertical && <XIcons.MoreHorizontal className={styles.XIcon}/>}
                {this.props.children}
            </div>
        );
    }
}